import { BookingModelQueryFragment } from '../constants/query_fragments';

export const GET_USER_PROFILE_BY_USER_ID_QUERY = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      spotifyPlaylistId
      profile {
        firstName
        lastName
        websiteLink
        bio
        profilePicture {
          bucket
          region
          key
        }
      }
    }
  }
`

export const GET_USER_STRIPE_ACCOUNT_QUERY = /* GraphQL */ `
query GetUserStripeAccount {
  getUserStripeAccount {
    id
    chargesEnabled
    onboarded
  }
}
`;

export const GET_USER_STRIPE_ONBOARDED_LINK_QUERY = /* GraphQL */ `
query GetUserStripeOnboardingLink($input: GetStripeOnboardingLinkInput) {
  getUserStripeOnboardingLink(input: $input) {
    url
  }
}
`;

export const GET_USER_STRIPE_LOGIN_LINK_QUERY = /* GraphQL */ `
query GetStripeLoginLink {
  getStripeLoginLink {
    url
  }
}
`;

export const UPDATE_USER_PROFILE_MUTATION = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      profile {
        firstName
        lastName
        profilePicture {
          bucket
          region
          key
        }
      }
    }
  }
`

export const SET_USER_SPOTIFY_PLAYLIST_ID = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      spotifyPlaylistId
    }
  }
`

export const GET_USER_SPOTIFY_PLAYLIST_ID_QUERY = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      spotifyPlaylistId
    }
  }
`

export const GET_USER_BOOKINGS_QUERY = /* GraphQL */ `
  query BookingsByRequesterIdAndId(
    $requesterId: ID!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    bookingsByRequesterIdAndId(
      requesterId: $requesterId
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ${BookingModelQueryFragment}
      }
      nextToken
    }
  }
`;

export const GET_BOOKINGS_BY_REQUESTER = /* GraphQL */ `
query BookingsByRequesterUserIdAndStartTime(
  $requesterUserId: ID!
  $sortDirection: ModelSortDirection
  $limit: Int
  $nextToken: String
) {
  bookingsByRequesterUserIdAndStartTime(
    requesterUserId: $requesterUserId
    sortDirection: $sortDirection
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      ${BookingModelQueryFragment}
    }
    nextToken
  }
}
`;

export const GET_BOOKINGS_BY_HOST = /* GraphQL */ `
query BookingsByHostUserIdAndStartTime(
  $hostUserId: ID!
  $sortDirection: ModelSortDirection
  $limit: Int
  $nextToken: String
) {
  bookingsByHostUserIdAndStartTime(
    hostUserId: $hostUserId
    sortDirection: $sortDirection
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      ${BookingModelQueryFragment}
    }
    nextToken
  }
}
`;
